import { PjnException } from '.';
import { ValidationException } from './local';
import { FieldValidationException, InvalidRequestException } from './server';
/**
 * Loguea en consola un error, variando el mensaje segun el tipo de error.
 *
 * @param accion descricion de la accion realizada donde se produjo un error
 * @param e error lanzado
 */
export function logError(accion, e) {
    if (!(e instanceof PjnException)) {
        console.error(`Error desconocido al ${accion}: ${JSON.stringify(e)}`);
        return e;
    }
    if (e instanceof ValidationException) {
        console.error(`Error de validacion local al ${accion}: ${JSON.stringify(e.errors)}`);
    }
    else if (e instanceof FieldValidationException) {
        console.error(`Error de validacion remota en los atributos al ${accion}: ${JSON.stringify(e.fields)}`);
    }
    else if (e instanceof InvalidRequestException) {
        console.error(`Error de validacion remota al ${accion}: ${JSON.stringify(e)}`);
    }
    else if (e instanceof PjnException) {
        console.error(`Error al ${accion}: ${e.message} -> ${JSON.stringify(e)}`);
    }
    else {
        console.error(`Error al ${accion}: ${JSON.stringify(e)}`);
    }
    return e;
}
//# sourceMappingURL=log.js.map